import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, useContext } from "react";
import Icon from "../../../../../../../base/icons/icon/index.js";
import contextBabylon from "../../../../../../../../context/index.js";
import { formatPriceWithCurrency } from "../../../../../../../../helpers/currency/index.js";
import { nullsToUndefined } from "../../../../../../../../helpers/null.js";
import * as S from "./styled.js";
export const ProductMobile = (props)=>{
    const { imageSrc , imageAlt , imageAlternative , title , description , search , link , price , priceFrom , info  } = props;
    const { Currency , Language  } = useContext(contextBabylon);
    const resize = {
        width: 158,
        height: 120,
        quality: 85,
        operation: 'resize'
    };
    return /*#__PURE__*/ _jsxs(S.ProductItemContainer, {
        ...nullsToUndefined(link),
        "data-testid": "ProductMobile",
        children: [
            /*#__PURE__*/ _jsxs(S.ProductItemImage, {
                children: [
                    imageSrc && /*#__PURE__*/ _jsx(S.ProductImage, {
                        resize: resize,
                        src: imageSrc,
                        alt: imageAlt,
                        alternative: imageAlternative,
                        title: title
                    }),
                    price && /*#__PURE__*/ _jsxs(S.ProductItemPriceContainer, {
                        children: [
                            /*#__PURE__*/ _jsx(S.ProductItemPriceFrom, {
                                children: priceFrom
                            }),
                            /*#__PURE__*/ _jsx(S.ProductItemPrice, {
                                children: formatPriceWithCurrency(price, Currency, Language)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(S.ProductItemContent, {
                children: [
                    title && /*#__PURE__*/ _jsx(S.ProductItemTitle, {
                        tag: "h3",
                        content: title
                    }),
                    description && /*#__PURE__*/ _jsx(S.ProductItemDesc, {
                        tag: "p",
                        content: description
                    }),
                    search && /*#__PURE__*/ _jsx(S.ProductItemSearch, {
                        tag: "p",
                        content: search
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(S.ProductItemFooter, {
                children: Children.toArray(info?.map((info)=>/*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                className: `nico-${info.icon}`
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: info.text
                            })
                        ]
                    })))
            })
        ]
    });
};
export default ProductMobile;

//# sourceMappingURL=index.js.map